import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import {TranslateModule} from "@ngx-translate/core";
import {LanguageManagerModule} from "../../language-manager/language-manager.module";
import {AuthService} from "../../auth/auth.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-new-app',
    imports: [TranslateModule, LanguageManagerModule],
    template: `
    <div class="m-5">
      <div style="height: 40px" class="flex justify-end">
        <app-lang-manager></app-lang-manager>
      </div>
      {{'main.new-app.text1' | translate}} <span style="color: red">{{timer}}</span> {{'main.new-app.text2' | translate}}
      <p class="link mt-5" (click)="redirect()">{{'main.new-app.link' | translate}}</p>
    </div>

  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [`
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100vh;
      width: 100vw;
      background: url(/assets/background3.jpg) no-repeat;
      background-size: cover;

      & > div {
        background: var(--color-white);
        @apply p-5;
        border-radius: 20px;
        max-width: 550px;
        font-size: 20px;
      }
    }
  `]
})
export class NewAppComponent implements OnInit{
  private router = inject(Router);


  timer = 30;
  interval;
  isVpn = false;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  ngOnInit() {
    fetch(window.location.origin + '/isvpn').then(res => {
      if(res.status === 200)
        res.json().then(body => this.isVpn = body.vpn)
      else
        this.isVpn = false;
    }).catch(() => {
      this.isVpn = false;
    }).finally(() => {
      if(this.isVpn) {
        //this.router.navigate(['/auth', 'secret-login'])
      }
    })

    this.interval = setInterval(() => {
      this.timer = this.timer - 1;
      if(this.timer === 0) {
        clearInterval(this.interval);
        this.redirect();
      }
    }, 1000)
  }

  redirect() {
    window.location.href = 'https://www.cargo-cube.com/scm/login.html?context=cargocube';
  }


}
